try
{
// console.log("Wizzy js called 1");
if(window.innerWidth <= 768)
{
  let desktop_search = document.querySelector('.header-item  .search__input');
  if(desktop_search)
  {
    desktop_search.remove();
  }
  let mobile_searchBar = document.querySelector('.site-header__element--sub .search__input');
  if(mobile_searchBar)
  {
    mobile_searchBar.classList.add("wizzy-search-input");
  }
}
const changeTemplate = (div) => {
  if (div === "wizzy-autocomplete-topproducts") {
    if (window.innerWidth > 768) {
    //   const oldDiv = document.getElementById(div);
    //   const newDiv = document.getElementById("wizzy-autocomplete-topproducts" + "-new").text;
    //   oldDiv.text = newDiv;
    // }
    // else {
      const oldDiv = document.getElementById(div);
      const newDiv = document.getElementById("wizzy-autocomplete-topproducts-desktop" + "-new").text;
      oldDiv.text = newDiv;
    }
    else if (window.innerWidth < 768) {
    //   const oldDiv = document.getElementById(div);
    //   const newDiv = document.getElementById("wizzy-autocomplete-topproducts" + "-new").text;
    //   oldDiv.text = newDiv;
    // }
    // else {
      const oldDiv = document.getElementById(div);
      const newDiv = document.getElementById("wizzy-autocomplete-topproducts-mobile" + "-new").text;
      oldDiv.text = newDiv;
    }

  // }else {
  //   const oldDiv = document.getElementById(div);
  //   const newDiv = document.getElementById(div + "-new").text;
  //   oldDiv.text = newDiv;
  // }
  }
};
// if(window.innerWidth <= 768)
// {
//   document.addEventListener('DOMContentLoaded', () => {
//     const placeholder = document.querySelector('.site-header__element--sub .search__input');
//     if (!placeholder) return;

//     const wrap = placeholder.querySelector('.wrap');
//     if (!wrap) return;
//     const words = ["Strollers", "Diaperning", "Baby Furnitur", "Apparel", "Maternity Clothing","Gifts"];

//     if (!words.length) return;

//     const period = 2000;

//     let currentWordIndex = 0;
//     let isDeleting = false;
//     let currentText = '';
//     let letterIndex = 0;

//     function typeEffect() {
//       const fullWord = words[currentWordIndex];

//       if (isDeleting) {
//         // Remove one character
//         letterIndex--;
//         currentText = fullWord.substring(0, letterIndex);
//       } else {
//         // Add one character
//         letterIndex++;
//         currentText = fullWord.substring(0, letterIndex);
//       }

//       wrap.textContent = currentText;

//       let typingSpeed = 200;

//       if (isDeleting) {
//         typingSpeed = 100; // faster deleting
//       }

//       if (!isDeleting && currentText === fullWord) {
//         // Pause at full word
//         typingSpeed = 300;
//         isDeleting = true;
//       } else if (isDeleting && currentText === '') {
//         // Move to next word
//         isDeleting = false;
//         currentWordIndex = (currentWordIndex + 1) % words.length;
//         typingSpeed = 300;
//       }

//       setTimeout(typeEffect, typingSpeed);
//     }

//     typeEffect();
//   });
// }

//Main code for placeholders
if (window.innerWidth <= 768) {
  document.addEventListener('DOMContentLoaded', () => {
    
    // const placeholder = document.querySelector('.site-header__element--sub .search__input');
    const placeholder = document.querySelector('#search_mini_form input');
    if (!placeholder) return;

    const words = ["Strollers", "Diapering", "Baby Furniture", "Apparel", "Maternity Clothing", "Gifts"];

    if (!words.length) return;

    const period = 2000;
    const staticText = "Search for "; // 🔹 always present

    let currentWordIndex = 0;
    let isDeleting = false;
    let currentText = '';
    let letterIndex = 0;

    function typeEffect() {
      const fullWord = words[currentWordIndex];

      if (isDeleting) {
        letterIndex--;
        currentText = fullWord.substring(0, letterIndex);
      } else {
        letterIndex++;
        currentText = fullWord.substring(0, letterIndex);
      }

      // 🔹 Keep "Search for " static + dynamic word
      placeholder.setAttribute('placeholder', staticText + currentText);

      let typingSpeed = 200;

      if (isDeleting) {
        typingSpeed = 100; // faster deleting
      }

      if (!isDeleting && currentText === fullWord) {
        typingSpeed = period; // pause before deleting
        isDeleting = true;
      } else if (isDeleting && currentText === '') {
        isDeleting = false;
        currentWordIndex = (currentWordIndex + 1) % words.length;
        typingSpeed = 300;
      }

      setTimeout(typeEffect, typingSpeed);
    }

    typeEffect();
  });
}



function checkWizzyConfigAndUpdate() {
    window.wizzyConfig && (window.matchMedia("(max-width: 768px)").matches ? window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: ".site-header__element--sub .search__input",
        type: "search"
    } : window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: ".header-item  .search__input",
        type: "search"
    },
    clearInterval(interval))
}
var interval = setInterval(checkWizzyConfigAndUpdate, 100);
// console.log("Wizzy js called 2", window.onWizzyScriptLoaded);

// desktop : ".header-item .search__input-wrap .search__input"
// var interval1 = setInterval(checkOnWizzyLoaded, 100);
// console.log("Wizzy js called 2", window.onWizzyScriptLoaded);


  // console.log("Load wizzy called");
  window.onWizzyScriptLoaded = function () {
  // console.log("Wizzy js called 2.5");
  $(document).on('click', '.wizzy-cart-button', function () {
    $(this).parents(".product-grid-item").find(".quick-add-btn").trigger('click');
    $(this).addClass("active");

    setTimeout(() => {
      $(this).removeClass("active");
    }, 2000);
  });
  // console.log("Wizzy js called 3");
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
  function (data) {
    if(window.innerWidth <= 768)
    {
      data.common.lazyDOMConfig.searchInputIdentifiers = [{
        dom: '.site-header__element--sub .search__input',
        type: "search"
      }]
    }
    else{
      data.common.lazyDOMConfig.searchInputIdentifiers = [{
        dom: '.header-item  .search__input',
        type: "search"
      }]
    }
    window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
      desktop: 3e3,
      mobile: 5e3,
    };
    data.filters.configs.keepOpenedInMobileAfterApply = true;
    try {
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        window.wizzyConfig.search.configs.facets.configs =
          window.wizzyConfig.search.configs.facets.configs.filter(
            (facet) => facet.key !== "sellingPrice"
          );
        // if(window.innerWidth <= 768)
        // {
        //   data.common.lazyDOMConfig.searchInputIdentifiers = [{
        //     dom: '.site-header__element--sub  .search__input#Search',
        //     type: "search"
        //   }]
        // }
        // else{
        //   data.common.lazyDOMConfig.searchInputIdentifiers = [{
        //     dom: '.header-item .search__input-wrap .search__input#Search',
        //     type: "search"
        //   }]
        // }
        window.wizzyConfig.search.configs.facets.configs.push({
          label: "Price",
          buckets: [
            {
              from: 0,
              to: 499,
            },
            {
              from: 500,
              to: 999,
            },
            {
              from: 1000,
              to: 1999,
            },
            {
              from: 2000,
              to: 2999,
            },
            {
              from: 3000,
              to: 4999,
            },
            {
              from: 5000,
              to: 6999,
            },
            {
              from: 7000,
              to: 9999,
            },
            {
              from: 10000,
              to: 19999,
            },
            {
              from: 20000,
              to: 49999,
            },
          ],
          key: "sellingPrice",
          position: "left",
          // order: 50
        });
      } catch (error) {}
    return data;
  });
  // console.log("Wizzy js called 4");
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
  function (data) {
    if(window.innerWidth <= 768)
    {
      data.common.lazyDOMConfig.searchInputIdentifiers = [{
        dom: '.site-header__element--sub .search__input',
        type: "search"
      }]
    }
    else{
      data.common.lazyDOMConfig.searchInputIdentifiers = [{
        dom: '.header-item  .search__input',
        type: "search"
      }]
    }
    // console.log("Before_lazy_init", data);
    // if(window.innerWidth <= 768)
    // {
    //   data.common.lazyDOMConfig.searchInputIdentifiers = [{
    //     dom: '.site-header__element--sub .search__input#Search',
    //     type: "search"
    //   }]
    // }
    // else{
    //   data.common.lazyDOMConfig.searchInputIdentifiers = [{
    //     dom: '.header-item .search__input-wrap .search__input#Search',
    //     type: "search"
    //   }]
    // }
    window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
      desktop: 3e3,
      mobile: 5e3,
    };
    data.filters.configs.keepOpenedInMobileAfterApply = true;
    try {
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        window.wizzyConfig.search.configs.facets.configs =
          window.wizzyConfig.search.configs.facets.configs.filter(
            (facet) => facet.key !== "sellingPrice"
          );
        window.wizzyConfig.search.configs.facets.configs.push({
          label: "Price",
          buckets: [
            {
              from: 0,
              to: 499,
            },
            {
              from: 500,
              to: 999,
            },
            {
              from: 1000,
              to: 1999,
            },
            {
              from: 2000,
              to: 2999,
            },
            {
              from: 3000,
              to: 4999,
            },
            {
              from: 5000,
              to: 6999,
            },
            {
              from: 7000,
              to: 9999,
            },
            {
              from: 10000,
              to: 19999,
            },
            {
              from: 20000,
              to: 49999,
            },
          ],
          key: "sellingPrice",
          position: "left",
          // order: 50
        });
        data.search.configs.pagination.appendInExistingList = true;
      } catch (error) {}
    return data;
  });
  // console.log("Wizzy js called 5");
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
  function (data) {
    // console.log(data);
    return data;
  });
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
  function (data) {
    // data.includeOutOfStock = false;
    // console.log("BEFORE_SEARCH_EXECUTED====>", data);
    // console.log(data.sort);
    // data.includeOutOfStock = false;
    // console.log(data.sort);
    if(window.innerWidth < 768)
    {
      document.querySelector(".wizzy-search-input").value = "";
    }
    let close_btn = document.querySelector('#search_mini_form .wizzy-search-back');
    if(close_btn)
    {
      close_btn.click();
    }
    let iDData = JSON.stringify([
      
        {
          key: "27223785572",
          inStock: [true, false]
        }
      ,
      
        {
          key: "81226170594",
          inStock: [true, false]
        }

      ,
      
        {
          key: "81202479330",
          inStock: [true, false]
        }
      ,
      
        {
          key: "81226268898",
          inStock: [true, false]
        },
        // {
        //   key: "73454813410",
        //   inStock: [true, false]
        // },
        // {
        //   key: "80652206306",
        //   inStock: [true, false]
        // }
       
      
    ]);
        if(document.querySelector('.page-width.page-content.page-content--top')){
          document.querySelector('.page-width.page-content.page-content--top').style.display="none";
        }
      // data.inventorySources = iDData;
    
    document.body.classList.add("wizzy-search");
    // data.facets.forEach((facet) => {
    //     if(facet.key === "discountPercentage")
    //     {
    //       facet.config = {
    //         interval: 10,
    //         limit:50
    //       }
    //     }
    //   })
    // console.log("before search executed", data);
    return data;
  }, 3);
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
  function (data) {
    // console.log("BEFORE_AUTOCOMPLETE_EXECUTED=====>", data);
    // data.includeOutOfStock = false;
    data.swatch = [
        {
            "key": "product_Size"
        },
        {
            "key": "product_Color"
        },
        {
            "key": "product_Style"
        },
      ]
    let iDData = JSON.stringify([
      
        {
          key: "27223785572",
          inStock: [true]
        }
      ,
      
        {
          key: "81226170594",
          inStock: [true]
        }

      ,
      
        {
          key: "81202479330",
          inStock: [true]
        }
      ,
      
        {
          key: "81226268898",
          inStock: [true]
        }
      ,
    ]);
      // data.inventorySources = iDData;
    return data;
  });
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
  function (data) {
    console.log("BEFORE_FILTERS_EXECUTED", data);
    // data.filters.showOOSProductsInOrder = "true";
    // if (window.wizzyConfig?.common?.isOnCategoryPage) {
    //      data.filters.boostGroupIds = [];
    // }

//   if (
//   window.wizzyConfig?.common?.isOnCategoryPage &&
//   data?.filters?.sort?.[0]?.field === 'relevance'
// ) {
//   data.filters.sort = data.filters.sort.slice(1);
// }
    // data.filters.includeOutOfStock = false;
    // data.filters.inStock = [true];
    // console.log(data.group);
    if(data.group === "defaultMenu" && data.filters && data.filters.sort)
    {
      data.filters.sort = [
      
      {
          field: "product_search-bestsellers_sortOrder:float",
          order: "asc"
      },
      
    ];
    }
    else if (data.filters.type === "NO_RESULTS_FOUND" && data.filters && data.filters.sort)
    {
      data.filters.sort = [{
          field: "product_bestseller_sortOrder:float",
          order: "asc"
      }, {
          field: "relevance",
          order: "asc"
      }];
    }
    if(data.filters.type === "AUTOCOMPLETE_DEFAULT")
    {
      data.filters.getAllVariants = false;
    }
    if(data.filters.type === "CATEGORY_PAGE")
    {
      data.filters.getAllVariants = false;
    //   const alreadyExists1 = data.filters.sort.some(
    //     (s) => s.field === "product_wizzy_variant_metafield_custom:string" && s.order === "desc"
    //   );
    //   if (!alreadyExists1 && data.filters.sort[0].field === "relevance") {
    //     data.filters.sort.push({ field: "product_wizzy_variant_metafield_custom:string", order: "desc", isForParent: !1 });
    // }
      const alreadyExists1 = data.filters.sort.some(
        (s) => s.field === "sellingPrice" && s.order === "asc"
      );
     if (!alreadyExists1 && data.filters.sort[0].field === "relevance") {
        data.filters.sort.push({ field: "sellingPrice", order: "asc", isForParent: !1 });
      }

      const alreadyExists = data.filters.sort.some(
        (s) => s.field === "discountPercentage" && s.order === "desc"
      );
      if (!alreadyExists && data.filters.sort[0].field === "relevance") {
        data.filters.sort.push({ field: "discountPercentage", order: "desc", isForParent: false });
      }
    }
    let sort_title = document.querySelector('.wizzy-common-select-options.title-mobile');
    if(sort_title)
    {
      sort_title.style.display = "none";
    }
    // console.log("BEFORE_FILTERS_EXECUTED=====>", data);
    if(window.wizzyConfig?.common?.isOnCategoryPage){
        let iDData = [
        {
          key: "27223785572",
          inStock: [true, false]
        },
        {
          key: "81226170594",
          inStock: [true, false]
        },
      
        {
          key: "81202479330",
          inStock: [true, false]
        },
        {
          key: "81226268898",
          inStock: [true, false]
        },
        // {
        //   key: "73454813410",
        //   inStock: [true, false]
        // },
        // {
        //   key: "80652206306",
        //   inStock: [true, false]
        // }
    ];
      // data.filters.inventorySources = iDData;
    }
    // console.log("BEFORE_FILTERS_EXECUTED", data)

    return data;
  },3);
  
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.PRODUCT_SWATCH_CLICKED,
  function (data) {
    // console.log("PRODUCT_SWATCH_CLICKED",data);
    return data;
  });
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
  function (products) {
    

    try{
    products.forEach((product) => {
      let product_sellingprice = product.sellingPrice;
      product_sellingprice = product_sellingprice.replace(".00", "");
      product.sellingPrice = product_sellingprice;
      let str = product.sellingPrice;
      let cleaned = str.replace(/,/g, '');
      let num = parseFloat(cleaned);
      let rounded = Math.round(num);
      let formatted = rounded.toLocaleString();
      product.sellingPrice = formatted;

      let product_price = product.price;
      product_price = product_price.replace(".00", "");
      product.price = product_price;
      str = product.price;
      cleaned = str.replace(/,/g, '');
      num = parseFloat(cleaned);
      rounded = Math.round(num);
      formatted = rounded.toLocaleString();
      product.price = formatted;
      // if(product.swatches)
      // {
      //   let swatches = product.swatches[0]?.values;
      //   if(swatches)
      //   {
      //     swatches = swatches.filter(swatch => swatch.inStock !== false);
      //     console.log(swatches);
      //     swatches.forEach((swatch) => {
      //         swatch.isSwatch = true;
      //         console.log(swatch.inStock);
      //     })
      //     product.swatches[0].values = swatches;
      //   }
        
        
      // }
      if(product.swatches)
      {
        let swatches = product.swatches[0]?.values;
        if(swatches)
        {
          swatches.forEach((swatch) => {
              swatch.isSwatch = true;
          })
        }
      }
      let attributes = product.attributes;
      if(attributes)
      {
        attributes.forEach((attr) => {
          if(attr.id === "product_tags"){
            if(attr.nestedValues)
            {
              let tagValues = attr.nestedValues[0].value[0];
              if(tagValues.includes('New Arrival')){
                product.isNewArrival = true;
              }
            }
            else
            {
              let tagValues = attr.values[0].value[0];
              if(tagValues.includes('New Arrival')){
                product.isNewArrival = true;
              }
              if(tagValues.includes('GIFT WITH PURCHASE')){
                product.isGiftPurchase = true;
              }
              if(tagValues.includes('pre-order')){
                product.pre_order = true;
              }
            }
          }

          if(attr.id === "product_inventory_sources_ids")
          {
            const restrictedIds = ["80652206306", "73454813410"];
            
            if(attr.nestedValues)
            {
              const allValues = attr.nestedValues.flatMap(v => v.value);
              const onlyRestricted = allValues.every(val => restrictedIds.includes(val));

              if (onlyRestricted) {
                product.inStock = false;
              }
            }
            else
            {
              const allValues = attr.values.flatMap(v => v.value);

              // Check if every value is inside restrictedIds
              const onlyRestricted = allValues.every(val => restrictedIds.includes(val));

              if (onlyRestricted) {
                product.inStock = false;
              }
            }
          }
          if(attr.id === "product_vendor")
          {
            if(attr.nestedValues)
            {
              product.vendor = attr.nestedValues[0].value[0];
            }
            else
            {
              product.vendor = attr.values[0].value[0];
            }
          }
          if(attr.id === "product_badge_judgeme")
          {
            if(attr.nestedValues)
            {
              product.reviews = attr.nestedValues[0].value[0];
            }
            else
            {
              product.reviews = attr.values[0].value[0];
            }
            
          }
          if(attr.id === "product__label_tags")
          {
            if(attr.nestedValues)
            {
              product.label = attr.nestedValues[0].value[0]
            }
            else
            {
              product.label = attr.values[0].value[0]
            }
            
          }
        });
      }
      
      
    })
    
  }catch(err){
    // console.log(err);
  }
  // console.log(products);
    return products;
  });
  function applyMultipleView()
  {
    let single_view = document.querySelector('.wizzy-tile-view-icon .wz-single-grid');
    let multiple_view = document.querySelector('.wizzy-tile-view-icon .wz-multiple-grid');
    localStorage.setItem('wizzy-tile-view', 2);
    let list = document.querySelector('.wizzy-search-results');
    if(list)
    {
      list.classList.remove('wz-single-view');
      list.classList.add('wz-multiple-view');
    }
    multiple_view.classList.add("selected");
    single_view.classList.remove("selected");
  }
  function applySingleView()
  {
    let single_view = document.querySelector('.wizzy-tile-view-icon .wz-single-grid');
    let multiple_view = document.querySelector('.wizzy-tile-view-icon .wz-multiple-grid');
    let list = document.querySelector('.wizzy-search-results');
    localStorage.setItem('wizzy-tile-view', 1);
    if(list)
    {
      list.classList.remove('wz-multiple-view');
      list.classList.add('wz-single-view');
    }
    multiple_view.classList.remove("selected");
    single_view.classList.add("selected");
  }
  function handleCloseSort() {
    let sort_btn = document.querySelector('.wizzy-common-select-selector');
    if (sort_btn) {
      sort_btn.click();
    }
  }
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
  function (data) {

    
    
    if(window.wizzyConfig.common.isOnCategoryPage)
    {
      document.body.classList.add("wizzy-collection");
    }
    let view = localStorage.getItem('wizzy-tile-view') || 2;
    if(view == 2)
    {
      applyMultipleView();
    }
    else
    {
      applySingleView();
    }
    let single_view = document.querySelector('.wizzy-tile-view-icon .wz-single-grid');
    let multiple_view = document.querySelector('.wizzy-tile-view-icon .wz-multiple-grid');
    // console.log("Inside views", single_view, multiple_view);
    if(single_view && multiple_view)
    {
      
      single_view.addEventListener("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        applySingleView();
      });
      multiple_view.addEventListener("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        applyMultipleView();
      });
    }
    let close_sort = document.querySelector('.wz-sort-close');
    if(close_sort)
    {
      close_sort.removeEventListener("click", handleCloseSort);
      close_sort.addEventListener("click", handleCloseSort);
    }
    var filterPanel = document.querySelectorAll(
      ".wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-facet-block .wizzy-facet-head"
    );

    filterPanel.forEach((facet) => {
      facet.addEventListener("click", function (e) {
        let currentFilter = this.closest(".wizzy-filters-facet-block");
        const isActive = currentFilter.classList.contains("collapsed");

        setTimeout(() => {
          filterPanel.forEach((h) => {
            let filter = h.closest(".wizzy-filters-facet-block");
            if (filter !== currentFilter) {
              filter.classList.add("collapsed");
              filter.classList.remove("first-opened");
            }
          });

          if (isActive) {
            currentFilter.classList.remove("collapsed");
          } else {
            currentFilter.classList.add("collapsed");
          }
        }, 100);
      });
    });

    let ranges = document.querySelectorAll(
      ".wizzy-facet-list-item.facet-rangeList-item .wizzy-facet-list-item-count"
    );
    ranges.forEach((range) => {
      if (range.textContent.trim() === "(0)") {
        range.parentElement.remove();
      }
    });


    gridFiltersToggleOnOverflow();
    // console.log(data);
    if(window._swat)
    {
      window._swat.initializeActionButtons(".wizzy-search-results");
    }
    return data;
  });
  // EMPTY_RESULTS_RENDERED
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.EMPTY_RESULTS_RENDERED,
  function (data) {
    // console.log("Empty res");
    window._swat.initializeActionButtons(".wizzy-search-results");
  });
  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
  function (data) {
    // console.log("products cache called");
    if(window.wizzyConfig.common.isOnCategoryPage)
    {
      document.body.classList.add("wizzy-collection");
    }
    let view = localStorage.getItem('wizzy-tile-view') || 2;
    if(view == 2)
    {
      applyMultipleView();
    }
    else
    {
      applySingleView();
    }
    let single_view = document.querySelector('.wizzy-tile-view-icon .wz-single-grid');
    let multiple_view = document.querySelector('.wizzy-tile-view-icon .wz-multiple-grid');
    // console.log("Inside views", single_view, multiple_view);
    if(single_view && multiple_view)
    {
      
      single_view.addEventListener("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        applySingleView();
      });
      multiple_view.addEventListener("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        applyMultipleView();
      });
    }
    let close_sort = document.querySelector('.wz-sort-close');
    if(close_sort)
    {
      close_sort.addEventListener("click", function(){
        let sort_btn = document.querySelector('.wizzy-common-select-selector');
        if(sort_btn)
        {
          sort_btn.click();
        }
      })
    }
    var filterPanel = document.querySelectorAll(
      ".wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-facet-block .wizzy-facet-head"
    );

    filterPanel.forEach((facet) => {
      facet.addEventListener("click", function (e) {
        let currentFilter = this.closest(".wizzy-filters-facet-block");
        const isActive = currentFilter.classList.contains("collapsed");

        setTimeout(() => {
          filterPanel.forEach((h) => {
            let filter = h.closest(".wizzy-filters-facet-block");
            if (filter !== currentFilter) {
              filter.classList.add("collapsed");
              filter.classList.remove("first-opened");
            }
          });

          if (isActive) {
            currentFilter.classList.remove("collapsed");
          } else {
            currentFilter.classList.add("collapsed");
          }
        }, 100);
      });
    });

    let ranges = document.querySelectorAll(
      ".wizzy-facet-list-item.facet-rangeList-item .wizzy-facet-list-item-count"
    );
    ranges.forEach((range) => {
      if (range.textContent.trim() === "(0)") {
        range.parentElement.remove();
      }
    });


    gridFiltersToggleOnOverflow();
    // console.log(data);
    if(window._swat)
    {
      window._swat.initializeActionButtons(".wizzy-search-results");
    }
    
    return data;
  });
  const targetNode = document.querySelector(".wizzy-body-end-wrapper");
  function updateBodyClass() {
      const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
      autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
      if(autocompleteElement)
      {
        const heads = document.querySelectorAll('.autocomplete-item-head');

        heads.forEach(head => {
          // get only the text part (ignores <a>)
          const textOnly = Array.from(head.childNodes)
            .filter(node => node.nodeType === Node.TEXT_NODE) // only text nodes
            .map(node => node.textContent.trim())
            .join(' ')
            .trim();

          if (textOnly === "Recent Searches") {
            let next = head.nextElementSibling;
            let count = 0;

            while (next && !next.classList.contains('autocomplete-item-head')) {
              if (next.classList.contains('autocomplete-item')) {
                count++;
                if (count > 5) {
                  next.remove();
                }
              }
              next = next.nextElementSibling;
            }
          }
        });
        let clearIcons = document.querySelectorAll('.wizzy-recent-search-clear-icon');
        clearIcons.forEach((icon) => {
          icon.addEventListener("click", function(){
            setTimeout(() => {
              if(window.innerWidth <= 768)
              {
                let searchbar = document.querySelector('.site-header__element--sub  .search__input.wizzy-search-input');
                if(searchbar)
                {
                  searchbar.click();
                }
              }
              else
              {
                let searchbar = document.querySelector('.header-item  .search__input.wizzy-search-input');
                if(searchbar)
                {
                  searchbar.click();
                }
              }
            }, 300);
            
          })
        });
        let clearAll = document.querySelector('.wizzy-recent-search-clear-all');
        if(clearAll)
        {
          clearAll.addEventListener("click", function(){
            setTimeout(() => {
              if(window.innerWidth <= 768)
              {
                let searchbar = document.querySelector('.site-header__element--sub  .search__input.wizzy-search-input');
                if(searchbar)
                {
                  searchbar.click();
                }
              }
              else
              {
                let searchbar = document.querySelector(' .header-item  .search__input.wizzy-search-input');
                if(searchbar)
                {
                  searchbar.click();
                }
              }
            }, 300);
          })
        }
      }
  }
  const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
  }
    , callback = function(mutationsList, observer2) {
      for (const mutation of mutationsList) {
          updateBodyClass();
          break
      }
  }
    , observer = new MutationObserver(callback);
  targetNode && (observer.observe(targetNode, config),
  updateBodyClass());



  changeTemplate("wizzy-autocomplete-topproducts");

}




function gridFiltersToggleOnOverflow() {
  if (window.innerWidth > 768) {
    const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");

    if (filterBoxes.length > 0) {
      filterBoxes.forEach((box) => {
        const filterList = box.querySelector(
          ".wizzy-facet-body .wizzy-facet-list"
        );
        const toggleBtn = box.querySelector(
          ".wizzy-facet-body .wizzy-toggle-btn"
        );
        const filterOptions = box.querySelector(".wizzy-facet-body");

        if (
          filterList &&
          toggleBtn &&
          filterOptions &&
          !toggleBtn.classList.contains("wizzy-click-event-attached")
        ) {
          const filterHeight = filterList.offsetHeight;
          const lineHeight = parseFloat(
            getComputedStyle(filterList).lineHeight
          );
          const maxVisibleLines = 2;
          const visibleLines = Math.floor(filterHeight / lineHeight) - 1;
          if (visibleLines > maxVisibleLines) {
            filterOptions.classList.add("collapsed");
            toggleBtn.classList.add("wizzy-click-event-attached");
            toggleBtn.style.display = "inline-block";
          } else {
            toggleBtn.style.display = "none";
          }

          toggleBtn.addEventListener("click", function () {
            if (filterOptions.classList.contains("collapsed")) {
              filterOptions.classList.remove("collapsed");
              filterOptions.classList.add("expanded");
              toggleBtn.innerText = "- Less";
            } else {
              filterOptions.classList.remove("expanded");
              filterOptions.classList.add("collapsed");
              toggleBtn.innerText = "+ More";
            }
            toggleBtn.classList.add("wizzy-click-event-attached");
          });
        }
      });
    }
  }
}
if(window.innerWidth <= 768)
    {
      const front_input = document.querySelector('.site-header__element--sub .search__input');
      
      // console.log("inside front and back", front_input);
      if(front_input)
      {
        // console.log("inside front and back");
        front_input.addEventListener("click", function(){
          // console.log("front clicked");
          const back_input = document.querySelector('#search_mini_form input');
          if(back_input)
            back_input.click();
          // back_input.click();
          // console.log(back_input);
          let search_form = document.querySelector('#search_mini_form');
          if(search_form)
          {
            search_form.style.display = "block";
            setTimeout(() => {
              let search_bar = search_form.querySelector("input");
              // console.log("SEARCH_BAR", search_bar);
              if(search_bar)
              {
                search_bar.click();
              }
            }, 300);
            
          }
          let autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
            if(autocomplete)
            {
              autocomplete.style.top = "83px";
            }
        })
      }
    }

// console.log("Wizzy js called last");
}
catch(err){
  // console.log("Error", err);
}